export default {
  QCManagementApi: {
    currentQcProjectStandard: '/api/QcProjectStandard/currentQcProjectStandard',
    distribution: {
      // 分配相关
      distributionPageList: 'api/QCDistributionApi/distributionPageList',
      // 质检员列表
      getQCUsers: 'api/QCDistributionApi/getQCUsers',
      addDistributionRecord: 'api/QCDistributionApi/addDistributionRecord',
      // 咨询件列表
      consultationPageList: 'api/QCDistributionApi/consultationPageList',
      //取消质检
      cancelDistribution: 'api/QCDistributionApi/cancelDistribution'
    },
    gauging: {
      // 质检员质检
      gaugingPageList: 'api/QCGaugingApi/gaugingPageList',
      gaugingResult: 'api/QCGaugingApi/gaugingResult',
      getGauging: 'api/QCGaugingApi/getGauging',
    },
    result: {
      // 质检结果
      resultPageList: 'api/QCResultApi/resultPageList',
      exportAllData: 'api/QCResultApi/exportAllData',
      getConsultationResult: 'api/QCResultApi/getConsultationResult',
      exportData: 'api/QCResultApi/exportResultData'
    }
  }
}